import React, { useEffect, useState } from "react";
import "./App.css";

import Btn from "./images/btn.png";

function getUrlParam(name: string) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|)"); //构造一个含有目标参数的正则表达式对象
  var r = window.location.search
    .trim()
    .substr(1)
    .match(reg); //匹配目标参数
  if (r != null) return unescape(r[2]);
  else return ""; //返回参数值
}

const GwUrl = [
  "http://e.hengdianworld.com/yd_mp_activity.aspx?id=710",
  "http://e.hengdianworld.com/yd_mp_activity.aspx?id=708",
  "http://e.hengdianworld.com/yd_mp_activity.aspx?id=709",
  "http://e.hengdianworld.com/yd_mp_activity.aspx?id=707"
];

const HywUrl = [
  "https://1599368mdyhd.sjdzp.cn/Miniwx/Index/buy.html?goods_id=4082567",
  "https://1599368mdyhd.sjdzp.cn/Miniwx/Index/buy.html?goods_id=3110262",
  "https://1599368mdyhd.sjdzp.cn/Miniwx/Index/buy.html?goods_id=3900170",
  "https://1599368mdyhd.sjdzp.cn/Miniwx/Index/buy.html?goods_id=4080131"
];
const pc = [
  "http://e.hengdianworld.com/VisitorTicketActivity.aspx?id=710",
  "http://e.hengdianworld.com/VisitorTicketActivity.aspx?id=708",
  "http://e.hengdianworld.com/VisitorTicketActivity.aspx?id=709",
  "http://e.hengdianworld.com/VisitorTicketActivity.aspx?id=707"
];

function App() {
  const [url, setUrl] = useState(GwUrl);
  const [pcurl, setPcUrl] = useState(pc);
  const [hyw, setHyw] = useState("0");
  useEffect(() => {
    const hywid = getUrlParam("hyw");
    setHyw(hyw => hywid);
    const uid = getUrlParam("uid") || "";
    const newList = GwUrl.map(item => item + `&uid=${uid}`);
    const pcnew = pcurl.map(item => item + `&uid=${uid}`);
    if (hywid === "1") {
      setUrl(url => HywUrl);
    } else if (uid) {
      setUrl(url => newList);
      setPcUrl(pcurl => pcnew);
    }
  }, []);

  if (
    !/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent) &&
    hyw !== "1"
  ) {
    return (
      <div className="pc">
        <img src={require("./images/pc_01.jpg")} alt="" />
        <img src={require("./images/pc_02.jpg")} alt="" useMap="#Map" />
        <map name="Map">
          <area
            shape="rect"
            coords="906,298,1472,460"
            href={pcurl[0]}
            alt="年卡"
            target="_blank"
          />
        </map>
        <img src={require("./images/pc_03.jpg")} alt="" useMap="#Map2" />
        <map name="Map2">
          <area
            shape="rect"
            coords="926,304,1454,451"
            href={pcurl[1]}
            alt="年卡"
            target="_blank"
          />
        </map>
        <img src={require("./images/pc_04.jpg")} alt="" useMap="#Map3" />
        <map name="Map3">
          <area
            shape="rect"
            coords="928,278,1451,447"
            href={pcurl[2]}
            alt="年卡"
            target="_blank"
          />
        </map>
        <img src={require("./images/pc_05.jpg")} alt="" useMap="#Map4" />
        <map name="Map4">
          <area
            shape="rect"
            coords="916,278,1455,466"
            href={pcurl[3]}
            alt="年卡"
            target="_blank"
          />
        </map>
      </div>
    );
  } else {
    return (
      <div className="App">
        <header></header>
        <div className="sec1">
          <a href={url[0]}>
            <img src={Btn} alt="" className="btn1 btn" />
          </a>
        </div>
        <div className="sec2">
          <a href={url[1]}>
            <img src={Btn} alt="" className="btn2 btn" />
          </a>
        </div>
        <div className="sec3">
          <a href={url[2]}>
            <img src={Btn} alt="" className="btn3 btn" />
          </a>
        </div>
        <div className="sec4">
          <a href={url[3]}>
            <img src={Btn} alt="" className="btn4 btn" />
          </a>
        </div>
      </div>
    );
  }
}

export default App;
